"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var focusNotVisible = ui_blocks_1.INTERACTIVE.focusNotVisible,
    focus = ui_blocks_1.INTERACTIVE.focus,
    focusInverse = ui_blocks_1.INTERACTIVE.focusInverse,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
var isCurrentStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  cursor: initial;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  cursor: initial;\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
var isCurrentInverseStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  cursor: initial;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:focus-visible {\n    outline: none;\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    outline: none;\n    ", "\n  }\n"], ["\n  cursor: initial;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:focus-visible {\n    outline: none;\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    outline: none;\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["700"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, focusInverse, focusInverse, focusNotVisible);
var isNotCurrentStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  outline: none;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    ", "\n  }\n"], ["\n  color: ", ";\n  outline: none;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["200"]', theme);
}, focus, focus, focusNotVisible);
var isNotCurrentInverseStyles = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  outline: none;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    ", "\n  }\n"], ["\n  color: ", ";\n  outline: none;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  &:focus:not(:focus-visible)::before {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["900"]', theme);
}, focusInverse, focusInverse, focusNotVisible);

var getButtonStyles = function getButtonStyles(_a) {
  var isInverse = _a.isInverse,
      isCurrent = _a.isCurrent;

  switch (true) {
    case !isInverse && isCurrent:
      return isCurrentStyles;

    case isInverse && isCurrent:
      return isCurrentInverseStyles;

    case !isInverse && !isCurrent:
      return isNotCurrentStyles;

    case isInverse && !isCurrent:
      return isNotCurrentInverseStyles;

    default:
      return;
  }
};

exports.Button = styled_components_1.default.button(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  min-width: ", ";\n  border-radius: ", ";\n  border: none;\n  background: none;\n  display: grid;\n  place-items: center;\n\n  &:disabled {\n    ", "\n    background: none;\n    color: ", ";\n\n    &:hover {\n      background: none;\n      color: ", ";\n    }\n  }\n\n  ", "\n"], ["\n  height: ", ";\n  min-width: ", ";\n  border-radius: ", ";\n  border: none;\n  background: none;\n  display: grid;\n  place-items: center;\n\n  &:disabled {\n    ", "\n    background: none;\n    color: ", ";\n\n    &:hover {\n      background: none;\n      color: ", ";\n    }\n  }\n\n  ", "\n"])), (0, ui_symbols_1.calcSpace)(4), (0, ui_symbols_1.calcSpace)(4), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.DEFAULT', theme);
}, isDisabled, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
  var isCurrent = _a.isCurrent,
      isInverse = _a.isInverse;
  return getButtonStyles({
    isInverse: isInverse,
    isCurrent: isCurrent
  });
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;